import React, { useState, useEffect } from "react";
import Header from "../../../Components/clubDashboard/Header/Header";
import Accordion from "react-bootstrap/Accordion";
import categoryIcon from "../../../assets/images/cat_Icon.png";
import { useNavigate,useLocation } from "react-router-dom";
import combinedServices from "../../../shared/services/user-service";
import moment from "moment";
import Swal from "sweetalert2";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import eyeIcon from "../../../assets/images/eye.svg";
import getLocalData from "../../../shared/localStorage/getData";
import crossIcon from "../../../assets/images/cross-icon.svg";

const POSOrderManagment = () => {
    const navigate = useNavigate();
    const [orderData, setOrderData] = useState([]);
    const [totalOrders, setTotalOrders] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [searchQuery, setSearchQuery] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [orderStatus, setOrderStatus] = useState("");
    const [updatedOrderStatus, setUpdatedOrderStatus] = useState("");
    const [refundedData, setRefundedData] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const totalPages = Math.ceil(totalOrders / limit);
    const location = useLocation();
    const storeId = location.state?.storeId;
    
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const orderResponse = await combinedServices.getallPOSorders(
                    page,
                    limit,
                    searchQuery,
                    paymentStatus,
                    orderStatus,
                    storeId
                );
                if (orderResponse?.data?.data) {
                    setOrderData(orderResponse.data.data || []);
                    setTotalOrders(orderResponse.data.total || 0);
                    console.log('asdsadsadsaorder', orderResponse)
                }
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };
        fetchOrders();
    }, [
        page,
        limit,
        searchQuery,
        paymentStatus,
        orderStatus,
        updatedOrderStatus,
        refundedData,
        refreshTrigger
    ]);

    useEffect(() => {

        if (getLocalData("user_info", "isLogin")) {
            var loginUserData = getLocalData("user_info", "all").userData.login_user_detail.data.user;
        }
        const fetchData = async () => {
            try {
                const pos = await combinedServices.userPOSstatus({ userID: loginUserData.id });
                console.log('asdasdsa', pos.data.data)
                if (pos.data.data.StorePOS) {
                    return
                } else {
                    navigate(`/club-dashboard`);
                }
            } catch (error) {
                console.error('Error fetching POS status:', error);
            }
        };

        fetchData();

    }, []);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleLimitChange = (e) => {
        setLimit(Number(e.target.value));
        setPage(1);
    };

    const handlePaymentStatusChange = (e) => {
        setPaymentStatus(e.target.value);
        setPage(1);
    };

    const handleOrderStatusChange = (e) => {
        setOrderStatus(e.target.value);
        setPage(1);
    };

    const groupedOrders = orderData.reduce((acc, order) => {
        if (!acc[order.order_id]) acc[order.order_id] = [];
        acc[order.order_id].push(order);
        return acc;
    }, {});

    const sortedGroupKeys = Object.keys(groupedOrders).sort(
        (a, b) =>
            new Date(groupedOrders[b][0].orderDate) -
            new Date(groupedOrders[a][0].orderDate)
    );

    const formatDate = (dateString) => {
        return moment(dateString).format("MM/DD/YYYY HH:mm:ss");
    };

    const updateOrderstatus = async (
        id,
        status,
        inv_id,
        userId,
        product_id,
        attribute,
        product
    ) => {
        try {
            const confirmResult = await Swal.fire({
                title: "Are you sure?",
                text: `You are about to update the order status to "${status}".`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, update it!",
                cancelButtonText: "No, cancel"
            });

            if (!confirmResult.isConfirmed) {
                return;
            }

            Swal.fire({
                title: "Updating...",
                text: "Please wait while we update the order status.",
                icon: "info",
                showConfirmButton: false,
                allowOutsideClick: false,
                timerProgressBar: true
            });

            const statusData = { id, status };
            const orderUpdateResponse = await combinedServices.updateOrderstatus(
                statusData
            );
            if (status === "Cancelled") {
                const parsedAttribute = JSON.parse(attribute);
                if (
                    (parsedAttribute.Classes || parsedAttribute.Transponders) &&
                    inv_id === 0 &&
                    product === null
                ) {
                    const cancelUserEventEntryResponse =
                        await combinedServices.cancelUserEventEntry({
                            id: id,
                            userID: userId,
                            eventId: product_id
                        });
                    setRefreshTrigger((prev) => prev + 1);
                }
            }
            if (orderUpdateResponse?.data) {
                setUpdatedOrderStatus(orderUpdateResponse.data || []);

                Swal.fire({
                    title: "Success!",
                    text: orderUpdateResponse.data.message,
                    icon: "success"
                });
            } else {
                Swal.fire({
                    title: "Error!",
                    text: "Failed to update the order status. Please try again.",
                    icon: "error"
                });
            }
        } catch (error) {
            console.error("Error Updating orders:", error);

            Swal.fire({
                title: "Error!",
                text: "An error occurred while updating the order status.",
                icon: "error"
            });
        }
    };

    const getStatusClass = (status, type) => {
        if (type === "payment") {
            return (
                {
                    COMPLETED: "status-completed-delivered",
                    Pending: "status-pending",
                    FAILED: "status-failed-cancelled"
                }[status] || "status-default"
            );
        }
        if (type === "order") {
            return (
                {
                    Delivered: "status-completed-delivered",
                    Pending: "status-pending",
                    Cancelled: "status-failed-cancelled"
                }[status] || "status-default"
            );
        }
    };

    const handleShowDetails = (order) => {
        setSelectedOrder(order);
        setShowDetailsModal(true);
    };

    const handleCloseDetails = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
    };

    const cancelPOSOrder = async (id, payment_id, price, inv_id, paymentType) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Do you really want to cancel this order?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, cancel it!",
                cancelButtonText: "No, keep it"
            });

            if (result.isConfirmed) {
                setIsLoading(true);

                const data = {
                    id: id,
                    payment_id: payment_id,
                    refundableAmount: price,
                    inv_id: inv_id,
                    paymentType: paymentType
                };

                const CancelOrderResponse = await combinedServices.CancelPOSOrder(data);
                console.log("CancelOrderResponse", CancelOrderResponse.data.status);

                if (CancelOrderResponse.data.status === 200) {
                    setRefundedData("REFUNDED");
                    Swal.fire(
                        "Cancelled!",
                        "Your order has been successfully cancelled.",
                        "success"
                    );
                    setIsLoading(false);
                } else {
                    Swal.fire("Failed!", "Failed to cancel the order.", "error");
                    setIsLoading(false);
                }
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
            Swal.fire(
                "Error!",
                "An error occurred while cancelling the order.",
                "error"
            );
            setIsLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case 'completed': return 'success';
            case 'pending': return 'warning';
            case 'cancelled': return 'danger';
            case 'shipped': return 'info';
            default: return 'secondary';
        }
    };

    const formatDates = (dateString) => {
        if (!dateString) return "N/A";
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <>
            <Header />
            <div className="dbAdminRight newDbRight" style={{ marginLeft: '-66px' }}>
                <div className="dbMid dbInner">
                    {isLoading && (
                        <div className="loadingOverlay">
                            <div className="loadingSpinner"></div>
                        </div>
                    )}
                    <div className="dbMainHd">POS Order Management</div>
                    <div className="catFilterWrp">
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="catFilterCont">
                                <div className="filWrp">
                                    <label className="label2">Showing</label>
                                    <select
                                        value={limit}
                                        onChange={handleLimitChange}
                                        className="form_ctrl ctrlDrop"
                                    >
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    <span className="ent">entries</span>
                                    <div className="filBtnWrp">
                                        <label className="label2">Payment Status</label>
                                        <select
                                            value={paymentStatus}
                                            onChange={handlePaymentStatusChange}
                                            className="form_ctrl ctrlDrop"
                                        >
                                            <option value="">All Payment</option>
                                            <option value="COMPLETED">Completed</option>
                                            <option value="PENDING">Pending</option>
                                            <option value="FAILED">Failed</option>
                                        </select>
                                        <span className="ent"></span>

                                        <div className="srchGrp">
                                            <label className="label2">Order Status</label>

                                            <select
                                                value={orderStatus}
                                                onChange={handleOrderStatusChange}
                                                className="form_ctrl ctrlDrop"
                                            >
                                                <option value="">All Orders</option>
                                                <option value="Delivered">Delivered</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </select>
                                        </div>
                                    </div>
                                    <span className="ent"></span>

                                    <div className="srchGrp">
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            className="form_ctrl ctrlSrch"
                                            placeholder="Search with Order ID, Product Name or User Name"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="listTablWrp">
                        <div className="tblWrp">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="orderTableminweidth">
                                            Product Name
                                        </th>
                                        <th className="orderTableminweidth">Description</th>
                                        <th className="orderTableminweidth">Quantity</th>
                                        <th className="orderTableminweidth">Price</th>
                                        <th className="orderTableminweidth">Total</th>
                                        <th className="orderTableminweidth">Payment Status</th>
                                        <th className="orderTableminweidth">Payment Type</th>
                                        <th className="orderTableminweidth">UserType</th>
                                        <th className="orderTableminweidth">Ordered Date</th>
                                        <th className="orderTableminweidth">Action</th>
                                        {/* <th className="orderTableminweidth">Action</th> */}
                                    </tr>
                                </thead>
                            </table>
                            <Accordion defaultActiveKey="0">
                                {sortedGroupKeys.map((orderId, idx) => {
                                    const ordersWithSameId = groupedOrders[orderId];
                                    return (
                                        <Accordion.Item eventKey={String(idx)} key={orderId}>
                                            <Accordion.Header>
                                                <div className="accordion-header-content">
                                                    <div>
                                                        <strong>UserName:</strong> {ordersWithSameId[0]?.firstname + " " + ordersWithSameId[0]?.lastname || "N/A"}{" "}
                                                        <strong>Order ID:</strong> {orderId}{" "}
                                                        <strong>Username:</strong>{" "}
                                                        <strong>Order Date:</strong>{" "}
                                                        {formatDate(ordersWithSameId[0]?.orderDate) ||
                                                            "N/A"}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <table>
                                                    <tbody>
                                                        {ordersWithSameId.map((order) => {
                                                            const product = order.product || {};
                                                            const images = JSON.parse(order.image || "[]");
                                                            const orderAttributes = JSON.parse(
                                                                order.attribute || "{}"
                                                            );
                                                            const totalPrice =
                                                                order.quantity * order.unit_price;

                                                            return (
                                                                <tr key={order.id}>
                                                                    <td className="orderTableminweidth">
                                                                        <div className="catPara">
                                                                            <img
                                                                                src={images[0] || categoryIcon}
                                                                                alt={
                                                                                    order.product_name || "Product Image"
                                                                                }
                                                                            />
                                                                            {order.product_name || "N/A"}
                                                                        </div>
                                                                    </td>
                                                                    <td className="orderTableminweidth">
                                                                        {Object.keys(orderAttributes).length > 0 ? (
                                                                            Object.entries(orderAttributes).map(
                                                                                ([key, value]) => (
                                                                                    <div key={key}>
                                                                                        <strong>{key}:</strong>{" "}
                                                                                        {Array.isArray(value)
                                                                                            ? value.join(", ")
                                                                                            : value}
                                                                                    </div>
                                                                                )
                                                                            )
                                                                        ) : (
                                                                            <span>N/A</span>
                                                                        )}
                                                                    </td>

                                                                    <td className="orderTableminweidth">
                                                                        {order.quantity}
                                                                    </td>
                                                                    <td className="orderTableminweidth">
                                                                        ${order.unit_price || "N/A"}
                                                                    </td>
                                                                    <td className="orderTableminweidth">
                                                                        ${totalPrice.toFixed(2)}
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            className={`status-badge ${getStatusClass(
                                                                                order.paymentStatus,
                                                                                "payment"
                                                                            )}`}
                                                                        >
                                                                            {order.paymentStatus}
                                                                        </span>
                                                                    </td>

                                                                    <td className="orderTableminweidth">
                                                                        {order.paymentType === "paypal" ? "Paypal" :
                                                                            order.paymentType === "cash" ? "Cash" :
                                                                                "N/A"}
                                                                    </td>
                                                                    <td className="orderTableminweidth">
                                                                        {order.userType === "member" ? "Member" :
                                                                            order.userType === "nonmember" ? "Non Member" :
                                                                                "N/A"}
                                                                    </td>
                                                                    <td className="orderTableminweidth">
                                                                        {formatDate(order.orderDate) || "N/A"}
                                                                    </td>
                                                                    <td>
                                                                        <div className="tblBtnWrp" style={{ width: "110px" }}>
                                                                            <button
                                                                                className="Btn"
                                                                                onClick={() => handleShowDetails(order)}
                                                                            >
                                                                                <img src={eyeIcon} alt="eyeIcon" />
                                                                            </button>
                                                                            <button
                                                                                className="Btn"
                                                                                onClick={() => {
                                                                                    cancelPOSOrder(
                                                                                        order.id,
                                                                                        order.payment_id,
                                                                                        order.price,
                                                                                        order.inv_id,
                                                                                        order.paymentType
                                                                                    );
                                                                                }}
                                                                                disabled={order.paymentStatus !== "Success" && order.paymentStatus !== "Completed"}
                                                                            >
                                                                                <img
                                                                                    style={{
                                                                                        width: "21px",
                                                                                        opacity: (order.paymentStatus !== "Success" && order.paymentStatus !== "Completed") ? 0.5 : 1
                                                                                    }}
                                                                                    src={crossIcon}
                                                                                    alt="deleteIcon"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                })}
                            </Accordion>
                        </div>

                        {/* Pagination */}
                        <div className="tblPagiWrp">
                            <ul className="pagination namPagi">
                                <li>
                                    <button
                                        onClick={() => handlePageChange(page - 1)}
                                        disabled={page === 1}
                                    >
                                        Prev
                                    </button>
                                </li>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li key={index}>
                                        <button
                                            className={page === index + 1 ? "active" : ""}
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li>
                                    <button
                                        onClick={() => handlePageChange(page + 1)}
                                        disabled={page === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Order Details Modal */}
            <Modal show={showDetailsModal} onHide={handleCloseDetails} size="lg" centered>
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fw-bold">Order Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-1">
                    {selectedOrder && (
                        <div className="order-details-container">

                            <div className="order-details-section mb-4 p-3 bg-light rounded">
                                <h5 className="fw-bold mb-3 text-primary">
                                    <i className="bi bi-receipt me-2"></i>
                                    Ordered by Information
                                </h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Name : </span>
                                            <span className="detail-value font-monospace">
                                                {selectedOrder.addedByUser.user_firstname + ' ' + selectedOrder.addedByUser.user_lastname || "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Email ID : </span>
                                            <span className="detail-value font-monospace">
                                                {selectedOrder.addedByUser.user_email || "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Order Information Section */}
                            <div className="order-details-section mb-4 p-3 bg-light rounded">
                                <h5 className="fw-bold mb-3 text-primary">
                                    <i className="bi bi-receipt me-2"></i>
                                    Order Information
                                </h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Order Status:</span>
                                            <span className={`detail-value badge bg-${getStatusColor(selectedOrder.orderStatus)} ms-2`}>
                                                {selectedOrder.orderStatus}
                                            </span>
                                        </div>
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Order Date:</span>
                                            <span className="detail-value">{formatDates(selectedOrder.orderDate) || "N/A"}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Transaction ID:</span>
                                            <span className="detail-value font-monospace">
                                                {selectedOrder.transaction_id || "N/A"}
                                            </span>
                                        </div>
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Total Amount:</span>
                                            <span className="detail-value fw-bold">
                                                ${selectedOrder.price || "0.00"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Customer Information Section */}
                            <div className="order-details-section mb-4 p-3 bg-light rounded">
                                <h5 className="fw-bold mb-3 text-primary">
                                    <i className="bi bi-person-circle me-2"></i>
                                    Customer Information
                                </h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Name:</span>
                                            <span className="detail-value">
                                                {selectedOrder.firstname} {selectedOrder.lastname}
                                            </span>
                                        </div>
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Email:</span>
                                            <span className="detail-value">
                                                <a href={`mailto:${selectedOrder.email}`}>{selectedOrder.email}</a>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="detail-row mb-2">
                                            <span className="detail-label fw-medium">Phone:</span>
                                            <span className="detail-value">
                                                <a href={`tel:${selectedOrder.phone}`}>{selectedOrder.phone}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="detail-row mt-2">
                                    <span className="detail-label fw-medium">Billing Address:</span>
                                    <span className="detail-value d-block mt-1">
                                        {selectedOrder.billingaddress}
                                    </span>
                                </div>
                            </div>

                            {/* Products Section - Add if you have product data */}
                            {selectedOrder.items && (
                                <div className="order-details-section p-3 bg-light rounded">
                                    <h5 className="fw-bold mb-3 text-primary">
                                        <i className="bi bi-cart3 me-2"></i>
                                        Ordered Items
                                    </h5>
                                    <div className="table-responsive">
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedOrder.items.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.name}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>${item.price?.toFixed(2)}</td>
                                                        <td>${(item.price * item.quantity)?.toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0">
                    <Button variant="outline-secondary" onClick={handleCloseDetails}>
                        <i className="bi bi-x-lg me-1"></i> Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default POSOrderManagment;
